/* StartEndRenderer.js */

"use strict";
const ComboBoxControl = require("@gluenetworks/combobox").Single;
const InputNumberControl = require("@gluenetworks/input_number_control");
const ButtonControl = require("@gluenetworks/button_control");
const DateTimePickerPopup = require("../../common_components/date_time_picker_popup/DateTimePickerPopupComponent");
const RendererUtils = require("../../base/RendererUtils");
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");

class StartEndRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered() || this._model.options.noStartingEnding === true) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                const endBtnShow = !this.model._options.firstTime;

                this._startDateTimeComp = new DateTimePickerPopup(this._model, "start");
                this._startParts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "start",
                    "Starting",
                    this._startDateTimeComp
                );

                this._endDateTypeComp = new ComboBoxControl({
                    showFilter: false,
                    options: [
                        {label: "never", value: "never"},
                        {label: "on", value: "date"},
                        {label: "after", value: "count"},
                    ],
                    adjustWidth: true,
                });
                this._endDateTimePopupComp = new DateTimePickerPopup(this._model, "end");
                this._countControlComp = new InputNumberControl({value: 1, min: 1, max: 99});
                this._endNowButtonComp = new ButtonControl({label: "End Now", visible: endBtnShow});

                this._endParts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "end",
                    "Ending",
                    this._endDateTypeComp,
                    this._endDateTimePopupComp,
                    this._countControlComp,
                    "occurrences",
                    this._endNowButtonComp
                );
                this._countLabel = this._endParts[4];

                return Promise.all([
                    this._endDateTypeComp.renderer.render(),
                    this._startDateTimeComp.renderer.render(),
                    this._countControlComp.renderer.render(),
                    this._endNowButtonComp.renderer.render(),
                    this._endDateTimePopupComp.renderer.render(),
                ]);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._endParts ? this._startParts.concat(this._endParts) : new ComboBoxControl({});
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._startDateTimeComp.shutdown(),
                    this._endDateTypeComp.shutdown(),
                    this._endDateTimePopupComp.shutdown(),
                    this._countControlComp.shutdown(),
                    this._endNowButtonComp.shutdown(),
                ]);
            })
            .then(() => {
                this._startDateTimeComp = undefined;
                this._startParts = undefined;
                this._endDateTypeComp = undefined;
                this._endDateTimePopupComp = undefined;
                this._countControlComp = undefined;
                this._endParts = undefined;
                this._countLabel = undefined;
                this._endNowButtonComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    _registerListeners() {
        super._registerListeners();
        this._endDateTypeComp.on("UserValue", (this._onEndType = this._onEndType.bind(this)));
        this._countControlComp.on("UserValue", (this._onEndCount = this._onEndCount.bind(this)));
        this._endNowButtonComp.on("UserClick", (this._switchToNow = this._switchToNow.bind(this)));
    }
    _unregisterListeners() {
        super._unregisterListeners();
        this._endDateTypeComp.removeListener("UserValue", this._onEndType);
        this._countControlComp.removeListener("UserValue", this._onEndCount);
        this._endNowButtonComp.removeListener("UserClick", this._switchToNow);
    }

    _switchToNow() {
        const startDate = this._model.dateTimePropToDate("start"),
            currentDate = new Date();

        if (startDate > currentDate) {
            this._model.setScheduleProps({start: currentDate, count: undefined}, true);
        }
        this._model.setScheduleProps({end: currentDate, count: undefined}, true);
    }

    _onEndType(endType) {
        switch (endType) {
            case "count":
                this._model.setScheduleProps({end: undefined, count: 1}, true);
                break;
            case "date":
                this._model.setScheduleProps({end: new Date(), count: undefined}, true);
                break;
            default:
                this._model.setScheduleProps({end: undefined, count: undefined}, true);
        }
    }
    _onEndCount(count) {
        this._countLabel.innerText = count > 1 ? "occurrences" : "occurrence";
        this._model.setScheduleProp("count", count, true);
    }
    _setControlValuesFromModel() {
        let schedule = this._model.getSchedule();

        let count = schedule.count;
        this._endDateTypeComp.setValue(count ? "count" : schedule.date ? "date" : "never");
        let endDateType = "never";
        if (count) {
            endDateType = "count";
            this._countControlComp.setValue(count, false);
        } else if (schedule.end) {
            endDateType = "date";
        }
        this._endDateTypeComp.setValue(endDateType);
        switch (endDateType) {
            case "date":
                RendererUtils.showElements(this._endDateTimePopupComp);
                RendererUtils.hideElements(this._countControlComp, this._countLabel);
                break;
            case "count":
                RendererUtils.hideElements(this._endDateTimePopupComp);
                RendererUtils.showElements(this._countControlComp, this._countLabel);
                break;
            default:
                RendererUtils.hideElements(
                    this._endDateTimePopupComp,
                    this._countControlComp,
                    this._countLabel
                );
        }
    }
}
module.exports = StartEndRenderer;
